// CargarCompetencias.jsx - Componente para cargar competencias desde la aplicación
import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';

const CargarCompetencias = () => {
  const [cargando, setCargando] = useState(false);
  const [resultado, setResultado] = useState('');

  // Datos de las 20 competencias
  const competencias = [
    // LIDERAZGO Y GESTIÓN
    {
      nombre: "Liderazgo",
      descripcion: "La capacidad de inspirar, guiar e influir en otros para alcanzar objetivos comunes. Incluye establecer una visión, tomar decisiones estratégicas y motivar a los miembros del equipo para que rindan al máximo.",
      categoria: "Liderazgo y Gestión",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "alto"
    },
    {
      nombre: "Gestión de equipos",
      descripcion: "Habilidades para organizar, dirigir y desarrollar a los miembros del equipo. Abarca la delegación, la asignación de recursos, la supervisión del rendimiento y la creación de un entorno que fomente la colaboración y la productividad.",
      categoria: "Liderazgo y Gestión",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "alto"
    },
    {
      nombre: "Toma de decisiones",
      descripcion: "Capacidad para analizar situaciones, evaluar opciones y emitir juicios acertados de manera oportuna. Incluye la toma de decisiones estratégicas y operativas en diversos niveles de incertidumbre.",
      categoria: "Liderazgo y Gestión",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "alto"
    },
    {
      nombre: "Pensamiento estratégico",
      descripcion: "La capacidad de ver el panorama general, anticipar tendencias futuras y desarrollar planes a largo plazo alineados con los objetivos organizacionales. Implica analizar las condiciones del mercado y el panorama competitivo.",
      categoria: "Liderazgo y Gestión",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "alto"
    },

    // COMUNICACIÓN E INTERPERSONAL
    {
      nombre: "Habilidades de comunicación",
      descripcion: "Competencia para transmitir información de forma clara y eficaz a través de diversos canales (verbal, escrito y digital). Incluye escucha activa, habilidades de presentación y adaptación del estilo comunicativo a diferentes públicos.",
      categoria: "Comunicación e Interpersonal",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "alto"
    },
    {
      nombre: "Trabajo en equipo y colaboración",
      descripcion: "La capacidad de trabajar eficazmente con otros, contribuir a los objetivos del equipo, compartir conocimientos y apoyar a los compañeros. Implica construir relaciones positivas y resolver conflictos de forma constructiva.",
      categoria: "Comunicación e Interpersonal",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "alto"
    },
    {
      nombre: "Orientación al servicio al cliente",
      descripcion: "Enfoque en comprender y satisfacer las necesidades de los clientes, tanto internos como externos. Incluye capacidad de respuesta, empatía y compromiso para brindar experiencias de servicio de alta calidad.",
      categoria: "Comunicación e Interpersonal",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "medio"
    },
    {
      nombre: "Habilidades interpersonales",
      descripcion: "La capacidad de interactuar eficazmente con personas de todos los niveles organizacionales. Abarca la inteligencia emocional, el desarrollo de relaciones, la creación de redes y la conciencia social.",
      categoria: "Comunicación e Interpersonal",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "alto"
    },

    // EFECTIVIDAD PERSONAL
    {
      nombre: "Resolución de problemas",
      descripcion: "Capacidad para identificar problemas, analizar sus causas, generar soluciones creativas e implementar soluciones eficaces. Incluye pensamiento crítico y razonamiento analítico.",
      categoria: "Efectividad Personal",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "alto"
    },
    {
      nombre: "Adaptabilidad y flexibilidad",
      descripcion: "La capacidad de adaptarse a circunstancias cambiantes, adoptar nuevos enfoques y mantener la eficacia en entornos dinámicos. Incluye la receptividad a la retroalimentación y el aprendizaje continuo.",
      categoria: "Efectividad Personal",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "alto"
    },
    {
      nombre: "Iniciativa y proactividad",
      descripcion: "Actuar sin que nadie se lo pida, identificar oportunidades de mejora e ir más allá de los requisitos básicos del puesto. Implica automotivación y pensamiento emprendedor.",
      categoria: "Efectividad Personal",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "medio"
    },
    {
      nombre: "Gestión del tiempo",
      descripcion: "La habilidad de organizar y priorizar tareas eficientemente, cumplir plazos y equilibrar múltiples responsabilidades. Incluye planificación, programación y optimización de la productividad.",
      categoria: "Efectividad Personal",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "medio"
    },

    // TÉCNICO Y PROFESIONAL
    {
      nombre: "Competencia técnica",
      descripcion: "Dominio de las habilidades, herramientas y conocimientos específicos del puesto necesarios para desempeñarlo eficazmente. Incluye mantenerse al día con las tendencias y las mejores prácticas del sector.",
      categoria: "Técnico y Profesional",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "alto"
    },
    {
      nombre: "Calidad del trabajo",
      descripcion: "Entrega constante de resultados precisos, exhaustivos y de alta calidad. Implica atención al detalle, precisión y compromiso con la excelencia en todos los entregables.",
      categoria: "Técnico y Profesional",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "alto"
    },
    {
      nombre: "Innovación y creatividad",
      descripcion: "La capacidad de generar nuevas ideas, desarrollar soluciones creativas e impulsar la innovación dentro de la organización. Incluye pensar de forma innovadora y desafiar los enfoques convencionales.",
      categoria: "Técnico y Profesional",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "medio"
    },
    {
      nombre: "Gestión de proyectos",
      descripcion: "Habilidades para planificar, ejecutar y entregar proyectos a tiempo y dentro del presupuesto. Abarca la gestión de recursos, la evaluación de riesgos y la coordinación con las partes interesadas.",
      categoria: "Técnico y Profesional",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "medio"
    },

    // ORGANIZACIONAL Y ÉTICO
    {
      nombre: "Logro de objetivos",
      descripcion: "Capacidad para establecer objetivos realistas, desarrollar planes de acción y alcanzar o superar constantemente los objetivos de rendimiento. Incluye persistencia, enfoque y orientación a resultados.",
      categoria: "Organizacional y Ético",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "alto"
    },
    {
      nombre: "Desarrollo profesional",
      descripcion: "Compromiso con el aprendizaje continuo, la mejora de habilidades y el crecimiento profesional. Implica buscar retroalimentación, aprovechar oportunidades de capacitación y mantenerse relevante en la profesión.",
      categoria: "Organizacional y Ético",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "medio"
    },
    {
      nombre: "Integridad y ética",
      descripcion: "Demostrar honestidad, transparencia y apego a los estándares morales y profesionales. Incluye confiabilidad, responsabilidad y un comportamiento ético consistente.",
      categoria: "Organizacional y Ético",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "alto"
    },
    {
      nombre: "Compromiso organizacional",
      descripcion: "Alineación con los valores, la cultura y los objetivos de la empresa. Implica lealtad, compromiso y disposición para contribuir al éxito organizacional más allá de las responsabilidades individuales.",
      categoria: "Organizacional y Ético",
      estado: "activo",
      fechaCreacion: new Date(),
      nivelImportancia: "medio"
    }
  ];

  const cargarCompetencias = async () => {
    setCargando(true);
    setResultado('');
    let log = '';

    try {
      log += "📚 Iniciando carga de competencias...\n";
      
      for (let i = 0; i < competencias.length; i++) {
        const competencia = competencias[i];
        
        try {
          const docRef = await addDoc(collection(db, "competencias"), competencia);
          const mensaje = `✅ ${i + 1}/20: "${competencia.nombre}" (${competencia.categoria})\n`;
          log += mensaje;
          setResultado(log);
          console.log(mensaje);
        } catch (error) {
          const mensaje = `❌ Error con "${competencia.nombre}": ${error.message}\n`;
          log += mensaje;
          setResultado(log);
          console.error(mensaje, error);
        }
      }

      log += "\n🎉 ¡Proceso completado!\n";
      log += "📊 Resumen por categorías:\n";
      log += "- Liderazgo y Gestión: 4 competencias\n";
      log += "- Comunicación e Interpersonal: 4 competencias\n";
      log += "- Efectividad Personal: 4 competencias\n";
      log += "- Técnico y Profesional: 4 competencias\n";
      log += "- Organizacional y Ético: 4 competencias\n";
      log += "- Total: 20 competencias\n";

      setResultado(log);
      
    } catch (error) {
      const mensaje = `❌ Error general: ${error.message}\n`;
      log += mensaje;
      setResultado(log);
      console.error("Error:", error);
    } finally {
      setCargando(false);
    }
  };

  return (
    <div style={{ padding: '20px', backgroundColor: '#1a1a1a', color: 'white', borderRadius: '8px', margin: '20px' }}>
      <h2>🚀 Cargar Competencias de Evaluación 360°</h2>
      <p>Este script cargará las 20 competencias organizadas en 5 categorías en Firebase.</p>
      
      <button 
        onClick={cargarCompetencias}
        disabled={cargando}
        style={{
          backgroundColor: cargando ? '#666' : '#007bff',
          color: 'white',
          border: 'none',
          padding: '12px 24px',
          borderRadius: '6px',
          cursor: cargando ? 'not-allowed' : 'pointer',
          fontSize: '16px',
          marginBottom: '20px'
        }}
      >
        {cargando ? '⏳ Cargando...' : '📚 Cargar Competencias'}
      </button>

      {resultado && (
        <div style={{
          backgroundColor: '#2d2d2d',
          padding: '15px',
          borderRadius: '6px',
          fontFamily: 'monospace',
          fontSize: '14px',
          whiteSpace: 'pre-wrap',
          maxHeight: '400px',
          overflowY: 'auto',
          border: '1px solid #555'
        }}>
          {resultado}
        </div>
      )}
    </div>
  );
};

export default CargarCompetencias;
